/* eslint-disable no-restricted-globals */
import React, { useState } from "react";
import { cloneDeep } from "lodash";
import colors from "../../config/colors";
import { RiBankFill, RiPhoneFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { BiPlus } from "react-icons/bi";
import { AiFillTag } from "react-icons/ai";
import AppInput from "../../common/AppInput";
import AppButton from "../../common/AppButton";
import LabelText from "../../common/LabelText";
import api from "../../config/api";
import { Modal } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import { IoLocationSharp, IoPersonCircle } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLocations } from "../../stores/LocationStore";

const size = 25;
const formInit = {
  name: "",
  phone: "",
  email: "",
  billingAddress: "",
  locations: [
    {
      title: "",
      tag: "",
      incharge: "",
      contact: "",
    },
  ],
};
function OrganizationShowModel() {
  const queryClient = useQueryClient();
  const { data: locationsData } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const Body = ({ organization, onDone }) => {
    const [form, setForm] = useState(
      cloneDeep({
        ...organization,
        locations: organization.locations.map((i) =>
          locationsData?.find((item) => item._id === i)
        ),
      })
    );
    const [editable, setEditable] = useState(false);
    const newLocation = () => {
      setForm({
        ...form,
        locations: [...form.locations, cloneDeep(formInit.locations[0])],
      });
    };

    const handleLocationChange = ({ target }, ind) => {
      const value = target.value;
      const name = target.name;
      const locations = [...form.locations];
      locations[ind][name] = value;
      setForm({ ...form, locations });
    };

    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };

    const handleSubmit = async (event) => {
      event.preventDefault();

      const res = await api.put("organizations", form);
      if (!res.ok) {
        return toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["organizations"]);
      toast.success("Changes has been successfully saved.");

      onDone && onDone();
    };

    const handleDelete = async () => {
      if (confirm("Are you sure want to delete the Client ?") === false)
        return false;
      const res = await api.put("organizations", {
        ...form,
        isDeleted: true,
      });
      if (!res.ok) return toast.error(res.originalError.message);
      queryClient.invalidateQueries(["organizations"]);

      toast.success("Client has been successfully deleted.");

      onDone && onDone();
    };
    return (
      <React.Fragment>
        <Modal.Header closeButton>
          <div
            className="d-flex"
            style={{ justifyContent: "space-between", width: "100%" }}
          >
            <span className="d-flex" style={{ alignItems: "center" }}>
              <b>Client's Details</b>
            </span>
            {!editable && (
              <AppButton
                onClick={() => setEditable(true)}
                text="Edit"
                className="text-primary"
              />
            )}
            {editable && (
              <AppButton
                onClick={handleDelete}
                text="Delete"
                className="text-danger"
              />
            )}
          </div>
        </Modal.Header>
        <Modal.Body
          style={{ overflowY: "scroll" }}
          // style={{
          //   zIndex: 15,
          //   overflow: "auto",
          //   maxHeight: "60vh",
          //   padding: 5,
          // }}
        >
          <form id="form" onSubmit={handleSubmit}>
            <div
              className="d-flex"
              style={{
                flexDirection: "column",
                gap: "20px",
                padding: "0px 30px",
                // maxHeight: 500,
                // overflowY: "auto",
              }}
            >
              <div className="d-flex" style={{ gap: 20 }}>
                <AppInput
                  label="Name"
                  autoFocus
                  name="name"
                  onChange={handleChange}
                  leftIcon={<RiBankFill size={size} color={colors.silver} />}
                  floatLabel
                  value={form.name}
                  inputType="text"
                  required
                  showMode={!editable}
                />
                <AppInput
                  label="Care Of"
                  floatLabel
                  showMode={!editable}
                  name="careOf"
                  value={form.careOf}
                  onChange={handleChange}
                  leftIcon={
                    <IoLocationSharp size={size} color={colors.silver} />
                  }
                />
              </div>

              <div className="d-flex" style={{ gap: 20 }}>
                <AppInput
                  label="Phone"
                  floatLabel
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  showMode={!editable}
                  inputType="tel"
                  leftIcon={<RiPhoneFill size={size} color={colors.silver} />}
                />
                <AppInput
                  label="Email"
                  floatLabel
                  name="email"
                  inputType="email"
                  required
                  showMode={!editable}
                  value={form.email}
                  onChange={handleChange}
                  leftIcon={<MdEmail size={size} color={colors.silver} />}
                />
              </div>
              <div>
                <AppInput
                  label="Billing Address"
                  floatLabel
                  name="billingAddress"
                  showMode={!editable}
                  value={form.billingAddress}
                  onChange={handleChange}
                  leftIcon={
                    <IoLocationSharp size={size} color={colors.silver} />
                  }
                />
              </div>

              <LabelText label="Locations" />
              {form.locations.length === 1 && (
                <div
                  style={{
                    border: "1px solid #77777720",
                    padding: 10,
                    borderRadius: 3,
                  }}
                >
                  <div className="d-flex" style={{ gap: 20 }}>
                    <AppInput
                      label="Administrator"
                      floatLabel
                      name="incharge"
                      showMode={!editable}
                      leftIcon={
                        <IoPersonCircle size={size} color={colors.silver} />
                      }
                      onChange={(event) => {
                        handleLocationChange(event, 0);
                      }}
                      value={form.locations[0].incharge}
                    />
                    <AppInput
                      label="Designation"
                      floatLabel
                      name="tag"
                      showMode={!editable}
                      leftIcon={<AiFillTag size={size} color={colors.silver} />}
                      onChange={(event) => {
                        handleLocationChange(event, 0);
                      }}
                      value={form.locations[0].tag}
                    />

                    <AppInput
                      label="Contact"
                      floatLabel
                      name="contact"
                      showMode={!editable}
                      leftIcon={<IoIosMail size={size} color={colors.silver} />}
                      onChange={(event) => {
                        handleLocationChange(event, 0);
                      }}
                      value={form.locations[0].contact}
                    />
                  </div>
                  <AppInput
                    showMode={!editable}
                    label="Location"
                    floatLabel
                    name="title"
                    onChange={(event) => {
                      handleLocationChange(event, 0);
                    }}
                    value={form.locations[0].title}
                    leftIcon={
                      <IoLocationSharp size={size} color={colors.silver} />
                    }
                    rightIcon={
                      editable && <BiPlus size={size} color={colors.silver} />
                    }
                    onClickRight={newLocation}
                  />
                </div>
              )}
              <div>
                {form.locations.length > 1 &&
                  form.locations.map((loc, ind) => {
                    const last = ind + 1 === form.locations.length;
                    return (
                      <div
                        key={String(ind)}
                        style={{
                          border: "1px solid #77777720",
                          padding: 10,
                          borderRadius: 3,
                          marginBottom: 15,
                        }}
                      >
                        <div>
                          <div className="d-flex" style={{ gap: 20 }}>
                            <AppInput
                              label="Administrator"
                              floatLabel
                              showMode={!editable}
                              name="incharge"
                              leftIcon={
                                <IoPersonCircle
                                  size={size}
                                  color={colors.silver}
                                />
                              }
                              onChange={(event) => {
                                handleLocationChange(event, ind);
                              }}
                              value={loc.incharge}
                            />
                            <AppInput
                              autoFocus
                              label="Designation"
                              showMode={!editable}
                              floatLabel
                              name="tag"
                              leftIcon={
                                <AiFillTag size={size} color={colors.silver} />
                              }
                              onChange={(event) => {
                                handleLocationChange(event, ind);
                              }}
                              value={loc.tag}
                            />

                            <AppInput
                              label="Contact"
                              floatLabel
                              showMode={!editable}
                              name="contact"
                              leftIcon={
                                <IoIosMail size={size} color={colors.silver} />
                              }
                              onChange={(event) => {
                                handleLocationChange(event, ind);
                              }}
                              value={loc.contact}
                            />
                          </div>
                        </div>
                        <AppInput
                          label="Location"
                          floatLabel
                          showMode={!editable}
                          name="title"
                          onChange={(event) => {
                            handleLocationChange(event, ind);
                          }}
                          value={loc.title}
                          leftIcon={
                            <IoLocationSharp
                              size={size}
                              color={colors.silver}
                            />
                          }
                          rightIcon={
                            editable &&
                            last && <BiPlus size={size} color={colors.silver} />
                          }
                          onClickRight={newLocation}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          {editable && (
            <AppButton
              form="form"
              text="Save"
              type="submit"
              className="text-primary"
            />
          )}
        </Modal.Footer>
      </React.Fragment>
    );
  };

  return {
    Body,
  };
}
export default OrganizationShowModel;
